// extracted by mini-css-extract-plugin
export var content = "cardProfile-module--content--e7ad5";
export var heading = "cardProfile-module--heading--51ff5";
export var img = "cardProfile-module--img--332e2";
export var imgContainer = "cardProfile-module--imgContainer--4e226";
export var subheading = "cardProfile-module--subheading--f59e2";
export var wrapper = "cardProfile-module--wrapper--1ce6e";